export default __webpack_public_path__ + "static/media/heart_outline.fadf8f9c.png";